import { useNavigation } from '../../function/navigation';
import Product from '../Product';

function SizeCheckWindings({
  inputs,
  result,
  convRatio,
  drawingBaseDimensions,
}) {
  const { nav } = useNavigation();
  const productToShow = inputs.product_tbh[nav.focusedProduct - 1];
  if (productToShow === undefined) return;

  const prodT =
    (drawingBaseDimensions.nbr_windings -
      1 +
      Math.acos(
        result.column_centre_to_inside_windings /
          result.column_centre_to_inside_outer_guide
      ) /
        (2 * Math.PI)) /
    drawingBaseDimensions.nbr_windings;

  return (
    <Product
      result={result}
      convRatio={convRatio}
      product={productToShow}
      t={prodT}
      clearance={true}
      clearance_type={'upper_end'}
      drawingBaseDimensions={drawingBaseDimensions}
      unitSystem={inputs.unit_system}
    />
  );
}

export default SizeCheckWindings;
